__turbopack_context__.v({
  "closeIcon": "Tooltip-module__VMFY6G__closeIcon",
  "darkMode": "Tooltip-module__VMFY6G__darkMode",
  "dialog": "Tooltip-module__VMFY6G__dialog",
  "infoIcon": "Tooltip-module__VMFY6G__infoIcon",
  "wrpr": "Tooltip-module__VMFY6G__wrpr",
});
